import React from 'react';
import {Layout, Row, Col, Button, Divider, Tooltip, Collapse} from "antd";
import {Content} from "antd/es/layout/layout";
import './style.scss'
import {FeatureText, QAText} from "./text";
import {ReactComponent as TickIcon} from "./Tick icon.svg"
import {ReactComponent as InfoIcon} from "./Information icon.svg"
import {PlusOutlined} from "@ant-design/icons";
import {PRODUCT_TEXT} from "../../text";
import unlock_img from './Cafe_01 1.png'

const {Panel} = Collapse;


const ProSubPage = (props) => {
    return (
        <Layout>
            <Content>
                <Row className={'pro-bg-color sub-head-row'} justify={'center'}>
                    <p className={'sub-title'}>Choose the plan that is right for you</p>
                    <p className={'sub-txt'}>
                        Start your Vieunite Pro journey with plans tailored for businesses of all sizes.
                    </p>
                    <p className={'sub-txt'} style={{margin: '-3vh 0 8vh 0'}}>
                        If you are unsure of the right plan, you can call us on 03455-481311
                    </p>
                </Row>
                <Row className={'pro-bg-color'}
                     justify={"center"}
                     style={{
                         columnGap: '2rem',
                         padding: '0 0 3rem 0'
                     }}
                >
                    <Col className={'sub-option'} lg={6}>
                        <p className={'sub-opt-title'}>Standard</p>
                        <p className={'sub-opt-subtitle'}>Free</p>
                        <p className={'sub-opt-per-year'} style={{color: "white"}}>per year</p>
                        <Button className={'sub-opt-btn'}
                                onClick={_ => window.location.href = '/business/shopping'}
                        >
                            Buy Now
                        </Button>
                        <p className={'sub-opt-small-title'}>Standard features:</p>
                        {FeatureText['Standard'].map((txtList, idx) => {
                            return (
                                <div>
                                    <div className={'sub-features-div'}>
                                        <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                        <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                    </div>
                                    <Divider style={{
                                        marginTop: '-0.3vh'
                                    }}/>
                                </div>
                            )
                        })}
                    </Col>
                    <Col className={'sub-option'} lg={6}>
                        <div className={'sub-most-popular'}>
                            Most popular
                        </div>
                        <p className={'sub-opt-title'}>Advanced</p>
                        <p className={'sub-opt-subtitle'}>£96</p>
                        <p className={'sub-opt-per-year'}>per year</p>
                        <Button className={'sub-opt-btn'}
                                onClick={_ => window.location.href = '/business/shopping'}
                        >
                            Buy Now
                        </Button>
                        <p className={'sub-opt-small-title'}>Intermediate features:</p>
                        {FeatureText['Advanced'].map((txtList, idx) => {
                            return (
                                <div>
                                    <div className={'sub-features-div'}>
                                        <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                        <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                    </div>
                                    <Divider style={{
                                        marginTop: '-0.3vh'
                                    }}/>
                                </div>

                            )
                        })}
                    </Col>
                    <Col className={'sub-option'} lg={6}>
                        <p className={'sub-opt-title'}>Premium</p>
                        <p className={'sub-opt-subtitle'}>POA</p>
                        <p className={'sub-opt-per-year'}>per year</p>
                        <Button className={'sub-opt-btn'}
                                onClick={_ => window.location.href = '/business/shopping'}
                        >
                            Buy Now
                        </Button>
                        <p className={'sub-opt-small-title'}>Advanced features:</p>
                        {FeatureText['Premium'].map((txtList, idx) => {
                            return (
                                <div>
                                    <div className={'sub-features-div'}>
                                        <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                        <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                    </div>
                                    <Divider style={{
                                        marginTop: '-0.3vh'
                                    }}/>
                                </div>
                            )
                        })}
                    </Col>
                </Row>
                <Row justify={"center"} style={{
                    backgroundColor: '#f4f4f4',
                    padding: '0 0 2rem 0'
                }}>
                    <p className={'sub-text-under'}>
                        When opting for the Vieunite Pro Advanced package, a one-time payment of £96 for a 12-month subscription is required at checkout.
                        Your subscription is per Textura digital canvas and will renew automatically every 12 months until you notify us of your intention to unsubscribe.
                    </p>
                </Row>
                <Row justify={"center"} style={{
                    // margin:'8rem 0 8rem 0',
                    backgroundColor: '#f4f4f4',
                }}>
                    <Col lg={12}
                         style={{
                             backgroundColor: "white",
                             display: "flex",
                             flexDirection: "column",
                             alignItems:'flex-end',
                             justifyContent:"center",
                         }}
                    >
                        <p className={'z-h1'}>Unlock a World of Art</p>
                        <p className={'z-txt'}>
                            Vieunite Pro provides businesses a curated<br/>
                            selection of artwork via a user-friendly portal.
                        </p>
                        <Button
                            className={'learn-more-btn pro-btn-hover-to-white'}
                            style={{}}
                            onClick={_ =>
                                window.location.href = '/business/textura-pro'}
                        >
                            Learn More
                        </Button>
                    </Col>
                    <Col lg={12}>
                        <img alt={'unlock'} src={unlock_img}/>
                    </Col>
                </Row>
                <Row justify={"center"} style={{
                    backgroundColor: '#f4f4f4',
                    color: '#f4f4f4',
                    border: "none",
                    paddingTop: '8rem'
                }}>
                    <Col span={20} lg={20} md={20}
                         style={{
                             backgroundColor: '#f4f4f4',
                             color: '#f4f4f4',
                             border: "none",
                             margin: '-4rem 0 -3rem 2rem'
                         }}
                    >
                        <p className={'qa-title'}>Frequently Asked Questions</p>
                    </Col>
                </Row>
                <Row justify={"center"}
                     style={{
                         backgroundColor: '#f4f4f4',
                     }}>
                    <Col span={20} lg={20} md={20}>
                        <Collapse expandIconPosition={"end"}
                                  bordered={false}
                                  style={{
                                      backgroundColor: '#f4f4f4',
                                      color: '#f4f4f4',
                                      border: "none"
                                  }}
                                  expandIcon={() => <PlusOutlined style={{
                                      fontSize: '24px', fontWeight: "900",
                                  }}/>}
                        >
                            {QAText.map((txt, idx) => {
                                return (
                                    <Panel header={txt[0]}
                                           style={{
                                               fontSize: '24px', fontWeight: "600",
                                           }}
                                           key={idx}>
                                        <p>{txt[1]}</p>
                                    </Panel>
                                )
                            })}
                        </Collapse>
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}

export default ProSubPage;
